// TODO
export default {
	location: false,
	camera: false,
	microphone: false,
	contacts: false,
	bluetooth: false,
	notifications: false,
}
